// ─── Marketplace Interaction Polish V1 ──────────────────────────────────────
// A single shared focus-visible ring for every bespoke button/anchor in the
// marketplace (SelectionAction, ExperienceMarketplaceRow, FeaturedShelf,
// SelectionTray, ComparisonDrawer) — none of them use the shared ui/button.tsx
// primitive (they're all inline-styled to match this design system's OKLCH
// palette instead), so none of them previously had ANY explicit focus-visible
// treatment — keyboard users fell back to the browser default outline, which
// is invisible or clashing against several of these backgrounds. One
// constant here means every surface gets the same ring instead of five
// slightly different ones drifting apart over time.
// Marketplace Grid Redesign + Provider Badges + Practical Filters V1 —
// ring color moved from the old editorial gold to the marketplace's own
// provisional accent (#E8194B), so every focus state lines up with the
// same "chips activos/estados seleccionados" color this sprint applies
// everywhere else. Scoped to this one shared constant — no other file
// hardcodes a ring color of its own.
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#E8194B]";
